import { IconProps } from "./Icon.model";

export function Slack({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83341 0.833496C8.91294 0.833496 8.16675 1.57969 8.16675 2.50016L8.16675 6.16683C8.16675 7.0873 8.91294 7.8335 9.83341 7.8335C10.7539 7.8335 11.5001 7.0873 11.5001 6.16683L11.5001 2.50016C11.5001 1.57969 10.7539 0.833496 9.83341 0.833496Z"
        fill={fillColor}
      />
      <path
        d="M6.16667 8.16699C5.24619 8.16699 4.5 8.91318 4.5 9.83366L4.5 13.5003C4.5 14.4208 5.24619 15.167 6.16667 15.167C7.08714 15.167 7.83333 14.4208 7.83333 13.5003L7.83333 9.83366C7.83333 8.91318 7.08714 8.16699 6.16667 8.16699Z"
        fill={fillColor}
      />
      <path
        d="M9.83341 8.16699C8.91294 8.16699 8.16675 8.91318 8.16675 9.83366C8.16675 10.7541 8.91294 11.5003 9.83341 11.5003L13.5001 11.5003C14.4206 11.5003 15.1667 10.7541 15.1667 9.83366C15.1667 8.91318 14.4206 8.16699 13.5001 8.16699L9.83341 8.16699Z"
        fill={fillColor}
      />
      <path
        d="M2.49992 4.5C1.57944 4.5 0.833252 5.24619 0.833252 6.16667C0.833252 7.08714 1.57944 7.83333 2.49992 7.83333L6.16659 7.83333C7.08706 7.83333 7.83325 7.08714 7.83325 6.16667C7.83325 5.24619 7.08706 4.5 6.16659 4.5L2.49992 4.5Z"
        fill={fillColor}
      />
      <path
        d="M5.83341 0.833496C4.91294 0.833496 4.16675 1.57969 4.16675 2.50016C4.16675 3.42064 4.91294 4.16683 5.83341 4.16683L7.00008 4.16683C7.27622 4.16683 7.50008 3.94297 7.50008 3.66683L7.50008 2.50016C7.50008 1.57969 6.75389 0.833496 5.83341 0.833496Z"
        fill={fillColor}
      />
      <path
        d="M9 11.8335C8.72386 11.8335 8.5 12.0574 8.5 12.3335V13.5002C8.5 14.4206 9.24619 15.1668 10.1667 15.1668C11.0871 15.1668 11.8333 14.4206 11.8333 13.5002C11.8333 12.5797 11.0871 11.8335 10.1667 11.8335H9Z"
        fill={fillColor}
      />
      <path
        d="M13.4999 4.16699C12.5794 4.16699 11.8333 4.91318 11.8333 5.83366V7.00033C11.8333 7.13293 11.8859 7.26011 11.9797 7.35388C12.0735 7.44765 12.2006 7.50033 12.3333 7.50033H13.4999C14.4204 7.50033 15.1666 6.75413 15.1666 5.83366C15.1666 4.91318 14.4204 4.16699 13.4999 4.16699Z"
        fill={fillColor}
      />
      <path
        d="M2.49992 8.5C1.57944 8.5 0.833252 9.24619 0.833252 10.1667C0.833252 11.0871 1.57944 11.8333 2.49992 11.8333C3.42039 11.8333 4.16659 11.0871 4.16659 10.1667V9C4.16659 8.72386 3.94273 8.5 3.66659 8.5H2.49992Z"
        fill={fillColor}
      />
    </svg>
  );
}

